import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { assertEndpointsConfigured } from './config/endpoints'
import './styles/globals.css'

// Fail fast in production builds if a required service URL env var is missing,
// rather than silently falling back to localhost.
assertEndpointsConfigured()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
// deploy timing probe 2026-10-03, no behavior change
